var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import cx from 'classnames';
const SvgIconComponent = (props, ref) => ((props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#5A5DC1",
  fillOpacity: 0.8,
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M29 20.99H11M27.68 12H12.32A1.32 1.32 0 0 0 11 13.31v10.38A1.32 1.32 0 0 0 12.32 25h15.36A1.32 1.32 0 0 0 29 23.69V13.31A1.32 1.32 0 0 0 27.68 12zM20 25v4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16.5 29h7"
}))))({
  ...props,
  className: cx('PA-Svg', props.className)
}, ref);
const SvgPublisher = SvgIconComponent;
const ForwardRef = /*#__PURE__*/forwardRef(SvgPublisher);
export default ForwardRef;